// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {RoleFormModuleLayout} from 'app_components/modules/admin/secure/roleForm'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import RoleService from 'app_services/admin/role/roleService'
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @import types
// @end

// @ADD Component types
interface IRoleFormModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
}
interface IRoleFormModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class RoleFormModule extends Component<IRoleFormModuleProps, IRoleFormModuleState> {

  private reactSelectService: ReactSelectService
  private roleService: RoleService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IRoleFormModuleProps) {
    super(props)
    this.state = {}

    this.reactSelectService = new ReactSelectService()
    this.roleService = new RoleService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onSubmit = async (data: any) => {

    if (data.app_module_permissions) data.app_module_permissions = this.reactSelectService.formatReactSelectResponse(data.app_module_permissions)

    const roleResponse = await this.roleService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    if (roleResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(roleResponse)
      }
    }

    this.setState({ status: null })
  }

  render() {
    return(
      <RoleFormModuleLayout
        {...this.props}
        onHandleSubmit={this.onSubmit}
        viewer={this.props.viewer}
      />
    )
  }
}

export default connect(mapStatesToProps)(RoleFormModule)
